import useIsMobile from 'utils/hooks/useIsMobile'
import {DataGridPro, GridRowId, useGridApiRef} from '@mui/x-data-grid-pro'
import {envBackHost, envImagePath, serverLocalName} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import fileDownload from 'js-file-download'
import CustomerDetailInfoMdal from 'pages/common/CustomerDetailInfoMdal'
import CustomerStatusTargetImageListModal from 'pages/common/CustomerStatusTargetImageListModal'
import ExcelDownLoadModal from 'pages/common/ExcelDownloadModal'
import PhotoModal from 'pages/common/PhotoModal'
import {
  customerStatusBoseongColumns,
  customerStatusColumns,
} from 'pages/customer/dataConfig/declearColumns'
import {customerStatusFilter} from 'pages/customer/dataConfig/declearFilters'
import {
  CustomerBusanStatusGroup,
  CustomerStatusGroup,
} from 'pages/customer/dataConfig/declearGroupingModel'
import {customerInfoRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {getCustomerList, getCustomerStatusList} from 'utils/apiCalling/api'
import {usePhotoModalOffice} from 'utils/config/photoConfig'
import {useServerCycleSetting} from 'utils/config/serverCycleConfig'
import {showBusanExcelHandler} from 'utils/const/globalController'
import {confirmPhotoAlert, resultAlert, warningPhotoAlert} from 'utils/CustomAlert/Alert'

import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {
  customerDetailModalClose,
  customerDetailModalOpen,
  imageDetailModalClose,
  imageDetailModalOpen,
  onRowsSelectionHandler,
  photoModalClose,
  photoModalOpen,
  scrollTop,
} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'
import CustomerStatusMobileCard from './CustomerStatusMobileCard'

const CustomerStatus = () => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const location = useLocation()
  const isMobile = useIsMobile()
  const userInfo = useSelector((state: any) => state?.userInfo)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  /* 통신주기 필터 노출 여부는 사업소마다 다르다 (/dev/server-cycle-config 에서 관리) */
  const serverCycle = useServerCycleSetting(officeInfo?.value)
  /* 행 클릭 시 사진 모달과 수용가 상세 중 무엇을 열지 (/dev/photo-config 에서 관리).
     컬럼 정의는 isPhotoModalOffice 를 직접 읽으므로, 설정이 도착하면 이 훅이
     화면을 다시 그려 컬럼 판정까지 함께 갱신한다. */
  const usePhotoModal = usePhotoModalOffice(officeInfo?.value)
  const cooperInfo = useSelector((state: any) => state?.cooperInfo)
  const pageState = location?.state
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [deviceDetailData, setDeviceDetailData] = useState<any>()
  const [checkData, setCheckData] = useState<any>([])
  const [customerDetailData, setCustomerDetailData] = useState<any>(null)
  const [customerInfoList, setCustomerInfoList] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<any>(null)
  const [selectionModel, setSelectionModel] = useState<GridRowId[]>([])
  const [filter, setFilter] = useState<any>(customerStatusFilter(pageState))
  const [imageDetailOpen, setImageDetailOpen] = useState<boolean>(false)
  const [customerDetailOpen, setCustomerDetailOpen] = useState<boolean>(false)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [downloadOpen, setDownloadOpen] = useState<boolean>(false)
  const [photoData, setPhotoData] = useState<any>({})
  const [photoModal, setPhotoModal] = useState<boolean>(false)
  const [targetRowId, setTargetRowId] = useState<any>(0)
  const [rows, setRows] = useState<any[]>([])
  const [shouldCallApi, setShouldCallApi] = useState<boolean>(false)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const openImageDetailModal = () => imageDetailModalOpen(setImageDetailOpen)
  const openCustomerDetailModal = () => customerDetailModalOpen(setCustomerDetailOpen)
  const closeImageDetailModal = () => imageDetailModalClose(setImageDetailOpen)
  const closeCustomerDetailModal = () => customerDetailModalClose(setCustomerDetailOpen)
  const closePhotoModal = () => photoModalClose(setPhotoModal)
  const openPhotoModal = () => photoModalOpen(setPhotoModal)

  const getphotoDownload = async (types: any) => {
    const customerNumberMap = checkData
      .filter((item: any) => item.existsInstallPhoto === true)
      .map((item: any) => item.customerNumber)
    const customerNumberList = customerNumberMap.join(',')

    const photoAlertTextHandler = (type: any, length: any) => {
      switch (type) {
        case 'excel':
          if (length > 50) {
            return '50개 이상 받으실 경우 Zip파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.'
          }
          return `선택한 수용가 중 사진첩이 있는 ${length}건이 엑셀 파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.`
        case 'pdf':
          return `선택한 수용가 중 사진첩이 있는 ${length}건이 PDF 파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.`
        default:
          return ''
      }
    }

    const isZip = customerNumberMap.length > 50 ? true : false

    const text = photoAlertTextHandler(types, customerNumberMap.length)

    if (customerNumberMap.length > 100) {
      await warningPhotoAlert()
      return false
    }

    switch (types) {
      case 'excel':
        if (await confirmPhotoAlert(text)) {
          await toast
            .promise(
              axiosWithAuth()
                .get(`${envBackHost}/customer/excel/photo/${officeInfo?.value}`, {
                  params: {customerNumbers: customerNumberList},
                  responseType: 'blob',
                })
                .then(async (res) => {
                  await resultAlert({resultCode: 0})
                  fileDownload(res.data, `${officeInfo?.label}_사진첩.${isZip ? 'zip' : 'xlsx'}`)
                })
                .catch(async (e) => {
                  await resultAlert({resultCode: 400})
                }),
              {
                pending: '다운로드 중입니다.',
              },
              {
                position: 'top-center',
                autoClose: 1000,
                className: 'fs-3  fw-bold',
                style: {width: '400px'},
              }
            )
            .catch(async (e) => {
              console.log(e)
              await resultAlert({resultCode: 400})
            })
        }
        break
      case 'pdf':
        if (await confirmPhotoAlert(text)) {
          await toast
            .promise(
              axiosWithAuth()
                .get(`${envBackHost}/customer/pdf/photo/${officeInfo?.value}`, {
                  params: {customerNumbers: customerNumberList},
                  responseType: 'blob',
                })
                .then(async (res) => {
                  await resultAlert({resultCode: 0})
                  fileDownload(res.data, `${officeInfo?.label}_사진첩.pdf`)
                })
                .catch(async (e) => {
                  await resultAlert({resultCode: 400})
                }),
              {
                pending: '다운로드 중입니다.',
              },
              {
                position: 'top-center',
                autoClose: 1000,
                className: 'fs-3  fw-bold',
                style: {width: '400px'},
              }
            )
            .catch(async (e) => {
              console.log(e)
              await resultAlert({resultCode: 400})
            })
        }
        break
      default:
        return null
    }
  }
  const apiRef = useGridApiRef()
  const getCustomerInfo = async () => {
    const handleResponse = async (res: any, count: any) => {
      const rows = customerInfoRows(res).map((row: any) => ({
        ...row,
        imageWidth: null,
        imageHeight: null,
      }))

      setCustomerInfoList(res)
      setRows(rows)
      setTotalCount(count)

      rows.forEach((row: any) => {
        if (row.filePath) {
          const img = new Image()
          img.src = envImagePath + row.filePath

          img.onload = () => {
            setRows((prev) =>
              prev.map((r) =>
                r.id === row.id && !r.imageWidth
                  ? {...r, imageWidth: img.width, imageHeight: img.height}
                  : r
              )
            )
          }

          img.onerror = () => {
            setRows((prev) =>
              prev.map((r) =>
                r.id === row.id && !r.imageWidth ? {...r, imageWidth: null, imageHeight: null} : r
              )
            )
          }
        }
      })
    }

    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    const hasAnyTrue = Object.values(filter.searchOption).some((v) => v === true)
    const newSearchOption =
      !filter.searchOption.customerNumber && hasAnyTrue
        ? {installer: false}
        : {customerNumber: true}
    let selectedFilter = filter
    if (checkBusan) {
      selectedFilter = {
        ...filter,
        searchOption: newSearchOption,
      }
    }
    if (checkBusan) {
      await getCustomerStatusList(
        officeInfo,
        cooperInfo,
        selectedFilter,
        (res: any, count: any) => {
          handleResponse(res, count)
        },
        (error: any) => {},
        () => {
          setLoading(loading)
        }
      )
    } else {
      await getCustomerList(
        officeInfo,
        cooperInfo,
        selectedFilter,
        (res: any, count: any) => {
          handleResponse(res, count)
        },
        (error: any) => {},
        () => {
          setLoading(loading)
        }
      )
    }
  }

  const busanSearchHandler = (officeId: any) => {
    const checkBusan = String(officeId).slice(0, 2) === '13'
    return ['customerNumber', 'customerName', 'address', 'managerName']
  }

  const columnHandler = (serverName: string): any => {
    switch (serverName) {
      case 'boseong':
        return customerStatusBoseongColumns(
          openImageDetailModal,
          openCustomerDetailModal,
          setCustomerDetailData,
          setDeviceDetailData,
          cooperInfo,
          officeInfo,
          openPhotoModal,
          setPhotoData,
          setTargetRowId
        )
      default:
        return customerStatusColumns(
          openImageDetailModal,
          openCustomerDetailModal,
          setCustomerDetailData,
          setDeviceDetailData,
          cooperInfo,
          officeInfo,
          openPhotoModal,
          setPhotoData,
          setTargetRowId
        )
    }
  }

  const groupingModel = !showBusanExcelHandler(serverLocalName, officeInfo?.value)
    ? CustomerBusanStatusGroup
    : CustomerStatusGroup

  const getRowHeightOnDataGrid = (params: any) => {
    const {imageHeight} = params?.model || {}
    // 매핑 테이블
    const heightMap: Record<number, number> = {
      480: 280,
      240: 260,
      144: 180,
    }

    if (imageHeight && heightMap[imageHeight]) {
      return heightMap[imageHeight] - 20
    }
    // 기본값
    return 160
  }
  const searchHandler = () => {
    setFilter((prev: any) => ({...prev, page: 1}))
    setShouldCallApi(true)
  }
  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  useEffect(() => {
    if (shouldCallApi) {
      getCustomerInfo()
      setShouldCallApi(false)
    }
  }, [filter, shouldCallApi])

  useEffect(() => {
    scrollTop()
    getCustomerInfo()
  }, [
    filter?.efosStatus,
    filter?.deviceStatus,
    filter?.deviceType,
    filter?.batteryStatus,
    filter.rowPerPage,
    filter?.page,
    filter?.serverCycle,
    officeInfo,
    cooperInfo,
  ])

  useEffect(() => {
    setFilter(customerStatusFilter(pageState))
  }, [officeInfo?.value])
  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerStatus.description}
        tooltipText={toolTipText.customerStatus.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'customer-status'}
        setFilter={setFilter}
        searchCallback={searchHandler}
        total={totalCount}
        control={[
          'device',
          'deviceType',
          'battery',
          ...(['B600', 'B6'].includes(officeInfo.value) ? ['uiseongDistrict'] : []),
          ...(serverCycle.pages.includes('status') ? ['serverCycle'] : []),
        ]}
        searchOptions={busanSearchHandler(officeInfo.value)}
        actions={[
          ...(['8401', '8400', '84'].includes(officeInfo?.value)
            ? [
                // 'photoDownload'
              ]
            : []),
          'download',
        ]}
        checkData={null}
        asValue={{
          setCheckData,
        }}
        onDelete={null}
        onCancel={null}
        setTypeName={null}
        onDownloadOpen={() => setDownloadOpen(true)}
        downloadApi={(type: any) => getphotoDownload(type)}
      >
        {/* [CHECKPOINT] 데스크탑 전용 DataGrid — 모바일에서는 CustomerStatusMobileCard로 대체됨
            롤백 시: isMobile 분기 제거 후 DataGridPro 블록만 남기면 됨 */}
        {isMobile ? (
          <CustomerStatusMobileCard
            rows={rows}
            loading={loading}
            cooperInfo={cooperInfo}
            officeInfo={officeInfo}
            usePhotoModal={usePhotoModal}
            onPhotoOpen={(row: any) => {
              setTargetRowId(row.id)
              setPhotoData(row)
              openPhotoModal()
            }}
            onImageDetailOpen={(row: any) => {
              setDeviceDetailData(row)
              openImageDetailModal()
            }}
            onCustomerDetailOpen={(row: any) => {
              setCustomerDetailData(row)
              openCustomerDetailModal()
            }}
          />
        ) : (
          <DataGridPro
            headerHeight={40}
            rowHeight={180}
            apiRef={apiRef}
            getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
            autoHeight={true}
            columnGroupingModel={groupingModel}
            experimentalFeatures={{columnGrouping: true}}
            rows={rows}
            rowCount={rows?.length}
            columns={columnHandler(serverLocalName)}
            disableColumnMenu
            loading={loading}
            // checkboxSelection
            // selectionModel={selectionModel}
            onSelectionModelChange={(ids, selection) => {
              const selectedRowsData = ids.map((id) => rows.find((row: any) => row.id === id))
              onRowsSelectionHandler(ids, [
                [setCheckData, selectedRowsData],
                [setSelectionModel, ids],
              ])
            }}
            paginationMode={'server'}
            hideFooterPagination={true}
            pagination={true}
            hideFooter={true}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
          />
        )}
        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>

      <CustomerStatusTargetImageListModal
        data={deviceDetailData}
        open={imageDetailOpen}
        onClose={closeImageDetailModal}
      />
      <CustomerDetailInfoMdal
        data={customerDetailData}
        open={customerDetailOpen}
        onClose={closeCustomerDetailModal}
        getList={getCustomerInfo}
        page='status'
      />
      <PhotoModal
        setData={setPhotoData}
        data={photoData}
        open={photoModal}
        onClose={closePhotoModal}
        page='status'
        rowCount={targetRowId}
        filter={filter}
        pagenation={filter.page}
        perPage={filter.rowPerPage}
        getList={getCustomerInfo}
        count={totalCount}
      />

      <ExcelDownLoadModal
        type={'수용가 현황'}
        search={filter}
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}
      />
    </>
  )
}
export default CustomerStatus
